export const isString = (s: any) => typeof s === 'string';

export const isEvent = (event: string) => (event.startsWith('on') ? event.toLowerCase() : `on${event}`) in window;
